import React, { useState } from 'react';
import Modal from './Modal';
import { changePassword } from '../AuthContext';

// Change-password modal (Navbar → "Password"). The kit's only self-serve
// credential path — there is no email recovery flow (instances often run
// without SMTP), so seeded operators rotate their temp password here.
export default function ChangePassword({ onClose }) {
  const [current, setCurrent] = useState('');
  const [next, setNext] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState(null);
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError(null);
    if (next.length < 8) return setError('New password must be at least 8 characters.');
    if (next !== confirm) return setError('New passwords do not match.');
    setBusy(true);
    try {
      await changePassword(current, next);
      setDone(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <Modal title="Change password" onClose={onClose} maxWidth={400}>
      {done ? (
        <>
          <p style={{ marginTop: 0 }}>Password updated — use it on your next sign-in.</p>
          <button className="cs-btn" onClick={onClose} style={{ width: '100%' }}>
            Done
          </button>
        </>
      ) : (
        <form onSubmit={submit}>
          {error && (
            <div className="cs-empty" style={{ padding: 12, marginBottom: 14, color: 'var(--accent)' }}>
              {error}
            </div>
          )}
          <div className="cs-field">
            <label>Current password</label>
            <input
              type="password"
              className="cs-input"
              value={current}
              onChange={(e) => setCurrent(e.target.value)}
              required
              autoComplete="current-password"
            />
          </div>
          <div className="cs-field">
            <label>New password</label>
            <input
              type="password"
              className="cs-input"
              value={next}
              onChange={(e) => setNext(e.target.value)}
              required
              minLength={8}
              autoComplete="new-password"
            />
          </div>
          <div className="cs-field">
            <label>Confirm new password</label>
            <input
              type="password"
              className="cs-input"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
              autoComplete="new-password"
            />
          </div>
          <button className="cs-btn" type="submit" disabled={busy} style={{ width: '100%', marginTop: 6 }}>
            {busy ? 'Updating…' : 'Update password'}
          </button>
        </form>
      )}
    </Modal>
  );
}
